import React, { useState, useEffect } from "react";
import Sidebar from "../../Layout/Sidebar";
import Loading from "react-fullscreen-loading";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { useNavigate } from "react-router-dom";
import { callAxios } from "../../../utils/axios";
import { toastMessage } from "../../../utils/toast";
import Pagination from "@mui/material/Pagination";
import moment from "moment";
import Modal from "@mui/material/Modal";
import ViewTicket from "./ViewTicket";
import { useTranslation } from "react-i18next";

const CustomTableHeadCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "transparent", // Customize cell background color
  fontWeight: "bold", // Customize cell text styling
  fontFamily: "Poppins",
  fontSize: "16px",
  lineHeight: "24px",
  borderBottom: "none",
  color: "#000",
}));
const CustomTableBodyCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#F4F4F4", // Customize cell background color
  fontFamily: "Poppins",
  fontSize: "16px",
  lineHeight: "24px",
  borderBottom: "none",
}));

const CustomTableHeadRow = styled(TableRow)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "#E0E0E0",
  },
  border: "none",
}));
const CustomTableBodyRow = styled(TableRow)(({ theme }) => ({
  marginBottom: "10px",
}));

const TicketsTable = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [tickets, setTickets] = useState([] as any);
  const [open, setOpen] = useState(false);
  const [existingData, setExistingData] = useState({} as any);

  const {t} = useTranslation()

  const getAllTickets = async () => {
    try {
      setLoading(true);
      const { data } = await callAxios(
        "get",
        `support/getAllSupportTickets?page=${page}&limit=10`
      );
      console.log(data);
      setTickets(data?.tickets);
      setLoading(false);
      setTotalPages(data?.totalPages);
    } catch (error) {
      console.log(error);
      setLoading(false);
      toastMessage(
        error?.response?.data?.message || "Something went wrong.",
        "error"
      );
    }
  };

  useEffect(() => {
    getAllTickets();
  }, [checked, page]);

  return (
    <>
      <Loading loading={loading} background="#fff" loaderColor="#719FE5" />
      <Sidebar>
        <div className="py-6 px-4 flex flex-col gap-8">
          <div className="w-full flex justify-between items-center">
            <div className="flex flex-col gap-2">
              <h1 className="text-[#23282D] poppins text-3xl font-semibold tracking-tight ">
              {t('adminRoute.supportTickets.title')}
              </h1>
              <p className="inter tracking-tight text-sm color-[#23282D]">
              {t('adminRoute.supportTickets.description')}   </p>
            </div>
          </div>
          <div className="w-full flex flex-col gap-3 ">
            <div className="w-full bg-white p-3 rounded shadow">
              <Table
                sx={{
                  borderSpacing: "0 15px !important",
                  borderCollapse: "separate !important",
                }}
              >
                <TableHead>
                  <CustomTableHeadRow>
                    <CustomTableHeadCell>{t('adminRoute.supportTickets.tableHeaders.title')} </CustomTableHeadCell>
                    <CustomTableHeadCell>{t('adminRoute.supportTickets.tableHeaders.category')} </CustomTableHeadCell>
                    <CustomTableHeadCell>{t('adminRoute.supportTickets.tableHeaders.description')} </CustomTableHeadCell>
                    <CustomTableHeadCell>{t('adminRoute.supportTickets.tableHeaders.images')} </CustomTableHeadCell>
                    <CustomTableHeadCell>{t('adminRoute.supportTickets.tableHeaders.user')}</CustomTableHeadCell>
                    <CustomTableHeadCell>{t('adminRoute.supportTickets.tableHeaders.status')}</CustomTableHeadCell>
                    <CustomTableHeadCell></CustomTableHeadCell>
                  </CustomTableHeadRow>
                </TableHead>
                <TableBody>
                  {tickets?.map((ticket: any) => {
                    return (
                      <CustomTableBodyRow
                        sx={{
                          marginBottom: "10px !important",
                        }}
                        key={ticket?._id}
                      >
                        <CustomTableBodyCell
                          sx={{
                            borderTopLeftRadius: "10px",
                            borderBottomLeftRadius: "10px",
                          }}
                        >
                          {ticket?.title}
                        </CustomTableBodyCell>
                        <CustomTableBodyCell>
                          {ticket?.category}
                        </CustomTableBodyCell>
                        <CustomTableBodyCell>
                          {ticket?.description.slice(0, 40)}
                        </CustomTableBodyCell>
                        <CustomTableBodyCell>
                          <div className="w-full flex gap-1">
                            {ticket?.images?.map((image: any) => {
                              return (
                                <img
                                  src={image}
                                  alt="image"
                                  className="w-10 h-10 rounded-md"
                                />
                              );
                            })}
                          </div>
                        </CustomTableBodyCell>
                        <CustomTableBodyCell>
                          {ticket?.user?.name}
                        </CustomTableBodyCell>
                        <CustomTableBodyCell
                          sx={{
                            borderTopRightRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        >
                          {ticket?.status}
                        </CustomTableBodyCell>
                        <CustomTableHeadCell>
                          <div className="w-full flex justify-center">
                            <button
                              onClick={() => {
                                console.log(ticket);
                                
                                setExistingData(ticket);
                                setOpen(true);
                              }}
                              className="bg-primary py-2 px-8 rounded-md text-white poppins text-sm font-normal"
                            >
                            {t('adminRoute.supportTickets.viewButton')}
                            </button>
                          </div>
                        </CustomTableHeadCell>
                      </CustomTableBodyRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
            <div className="w-full flex justify-end">
              <Pagination
                count={totalPages}
                variant="outlined"
                shape="rounded"
                color="primary"
                onChange={(e, value) => setPage(value)}
              />
            </div>
          </div>
        </div>
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ViewTicket
            checked={checked}
            setChecked={setChecked}
            setOpen={setOpen}
            existingData={existingData}
            open={open}
          />
        </Modal>
      </Sidebar>
    </>
  );
};

export default TicketsTable;
